import React from "react";

const Button = ({
  text = "",
  onClick,
  className = "",
  variant = "primary", // "primary" | "outline"
  disabled = false,
}) => {
  const baseStyles = `
    w-fluid-button h-10 px-fluid-button-x py-fluid-button-y
    rounded-full inline-flex items-center justify-center gap-fluid-1.5
    font-roboto text-fluid-sm font-semibold
    transition-none focus:outline-none
  `;

  const variantStyles = {
    primary: `
      bg-acs-primary-navy  text-[#F8FAFF]
      hover:bg-[#1E2A74] active:bg-[#16225e]
      dark:bg-acs-primary-navy-dark dark:text-[#F8FAFF]
      dark:hover:bg-[#1E2A74] dark:active:bg-[#16225e]
      shadow-sm hover:shadow-md active:shadow-inner
    `,
    outline: `
      border border-gray-300 text-gray-800 bg-transparent
      hover:bg-gray-100
      dark:border-acs-dark-border dark:text-acs-dark-text
      dark:hover:bg-acs-dark-hover/40
    `,
  };

  const disabledStyles = `
    opacity-50 cursor-not-allowed
  `;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        ${baseStyles}
        ${variantStyles[variant] || variantStyles.primary}
        ${disabled ? disabledStyles : ""}
        ${className}
      `}
    >
      {typeof text === "string" ? (
        <span className="whitespace-nowrap">{text}</span>
      ) : (
        <div className="whitespace-nowrap">{text}</div>
      )}
    </button>
  );
};

export default Button;
